// extracted by mini-css-extract-plugin
export var list = "MobileSearchSuggestions-module--list--a3fb0";
export var listItem = "MobileSearchSuggestions-module--listItem--1911f";